// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useAuth } from '../../context/auth';
// import { useNavigate } from 'react-router-dom';
// import "../cssStyle/PercentageCard.css";

// function HeroSession() {
//   const [showToggler, setShowToggler] = useState(true);
//   const [apiData, setApiData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
//   const [groupedData, setGroupedData] = useState({
//     left: [],
//     right: []
//   });
//   // Stats for left and right sections
//   const [leftStats, setLeftStats] = useState({ count: 0, average: 0 });
//   const [rightStats, setRightStats] = useState({ count: 0, average: 0 });
//   const [lastUpdated, setLastUpdated] = useState(null);
  
//   // Reference for interval
//   const intervalRef = useRef(null);
  
//   const { getAdminAuthToken } = useAuth();
//   const navigate = useNavigate();
//   const token = getAdminAuthToken();

//   // Format percentage function
//   const formatPercentage = (percentage) => {
//     const sign = percentage >= 0 ? '+' : '';
//     return `${sign}${percentage.toFixed(2)}%`;
//   };

//   const formatPrice = (price) => {
//     return `₹${price.toFixed(2)}`;
//   };

//   const formatTime = (time) => {
//     if (!time) return 'N/A';
//     const date = new Date(time);
//     return date.toLocaleString();
//   };

//   // ✅ Check if item type is ZERO ('0' or 0)
//   const isTypeZero = (item) => {
//     // Check for '0' string
//     if (item.type === '0') return true;
//     // Check for numeric 0
//     if (item.type === 0) return true;
//     // Check for numeric 0 as number
//     if (Number(item.type) === 0) return true;
//     return false;
//   };

//   // Fetch data function
//   const fetchData = async (showToast = false) => {
//     if (!token) {
//       setLoading(false);
//       if (showToast) toast.error("Please login first");
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }

//     try {
//       const response = await axios.get(
//         "https://api.algocontroller.com/admin_app/getting_admin_analysis",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       const rawData = response.data?.data || [];
//       setApiData(rawData);
//       processDataByCategory(rawData);
//       setLastUpdated(new Date());
//       setLoading(false);
      
//       if (showToast) {
//         toast.info(`Data updated!`, {
//           position: "top-right",
//           autoClose: 2000,
//           style: { fontSize: "12px" }
//         });
//       }
//     } catch (err) {
//       console.error("API Error:", err);
//       if (err.response?.status === 401) {
//         toast.error("Session expired. Please login again.");
//         setTimeout(() => navigate('/login'), 2000);
//       } else if (showToast) {
//         toast.error("Failed to fetch data");
//       }
//       setLoading(false);
//     }
//   };

//   const processDataByCategory = (rawData) => {
//     // GP category for LEFT (Positive/UPPER RANGE)
//     const leftCategories = ['GP'];
//     // GD category for RIGHT (Negative/DOWN RANGE)
//     const rightCategories = ['GD'];
    
//     let leftItems = [];
//     let rightItems = [];

//     rawData.forEach(insItem => {
//       if (insItem.data && Array.isArray(insItem.data)) {
//         insItem.data.forEach(item => {
//           // ✅ CRITICAL: ONLY show data where type is ZERO ('0' or 0)
//           if (!isTypeZero(item)) return;
          
//           console.log("✅ Zero type data found:", {
//             symbol: item.symbol,
//             type: item.type,
//             typeType: typeof item.type,
//             cat: item.cat,
//             percentage: item.percentage
//           });
          
//           const buttonData = {
//             symbol: item.symbol,
//             price: item.price,
//             percentage: item.percentage,
//             cat: item.cat,
//             type: parseFloat(item.percentage) >= 0 ? "green" : "red",
//             time: item.time,
//             ins_id: item.ins_id,
//             prev_row_close: item.prev_row_close,
//             originalType: item.type
//           };

//           if (leftCategories.includes(item.cat)) {
//             leftItems.push(buttonData);
//           } else if (rightCategories.includes(item.cat)) {
//             rightItems.push(buttonData);
//           }
//         });
//       }
//     });

//     console.log("📊 Zero Type Data Summary:", {
//       leftItemsCount: leftItems.length,
//       rightItemsCount: rightItems.length,
//       leftSample: leftItems.slice(0, 2),
//       rightSample: rightItems.slice(0, 2)
//     });

//     // Remove duplicates based on symbol
//     leftItems = removeDuplicates(leftItems);
//     rightItems = removeDuplicates(rightItems);

//     // SORTING: Descending order (higher percentage first) for GP
//     leftItems.sort((a, b) => b.percentage - a.percentage);
//     // SORTING: Ascending order (more negative first) for GD
//     rightItems.sort((a, b) => a.percentage - b.percentage);

//     // Calculate stats for LEFT section (GP)
//     const leftCount = leftItems.length;
//     const leftAvg = leftCount > 0 
//       ? leftItems.reduce((sum, item) => sum + item.percentage, 0) / leftCount 
//       : 0;
    
//     // Calculate stats for RIGHT section (GD)
//     const rightCount = rightItems.length;
//     const rightAvg = rightCount > 0 
//       ? rightItems.reduce((sum, item) => sum + item.percentage, 0) / rightCount 
//       : 0;

//     setLeftStats({ count: leftCount, average: leftAvg });
//     setRightStats({ count: rightCount, average: rightAvg });
//     setGroupedData({ left: leftItems, right: rightItems });
//   };

//   const removeDuplicates = (items) => {
//     const uniqueMap = new Map();
//     items.forEach(item => {
//       const key = `${item.symbol}_${item.cat}`;
//       if (!uniqueMap.has(key)) {
//         uniqueMap.set(key, item);
//       }
//     });
//     return Array.from(uniqueMap.values());
//   };

//   const copyToClipboard = async (text, label) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       toast.success(`${label} copied!`, {
//         position: "top-right",
//         autoClose: 1000,
//         style: { fontSize: "12px", padding: "6px 12px" }
//       });
//     } catch (err) {
//       const textarea = document.createElement("textarea");
//       textarea.value = text;
//       document.body.appendChild(textarea);
//       textarea.select();
//       document.execCommand("copy");
//       document.body.removeChild(textarea);
//       toast.info(`${label} copied!`);
//     }
//   };

//   // Manual refresh handler
//   const handleManualRefresh = () => {
//     fetchData(true);
//   };

//   // SMART TOOLTIP POSITIONING
//   const handleMouseEnter = (e, item) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const viewportWidth = window.innerWidth;
//     const viewportHeight = window.innerHeight;
    
//     let leftPos = rect.right + 10;
//     let topPos = rect.top;
    
//     const tooltipWidth = 260;
//     const tooltipHeight = 220;
    
//     if (leftPos + tooltipWidth > viewportWidth) {
//       leftPos = rect.left - tooltipWidth - 10;
//     }
    
//     if (leftPos < 10) {
//       leftPos = 10;
//     } 
    
//     if (topPos + tooltipHeight > viewportHeight) {
//       topPos = viewportHeight - tooltipHeight - 10;
//     }
    
//     if (topPos < 10) {
//       topPos = 10;
//     }
    
//     setHoverPosition({
//       x: leftPos,
//       y: topPos
//     });
//     setHoveredItem(item);
//   };

//   const handleMouseLeave = () => {
//     setHoveredItem(null);
//   };

//   // Initial fetch and set interval for every 10 seconds
//   useEffect(() => {
//     if (!token) {
//       setLoading(false);
//       toast.error("Please login first");
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }
    
//     // Initial fetch
//     fetchData(false);
    
//     // Set interval to fetch every 10 seconds
//     intervalRef.current = setInterval(() => {
//       console.log("Auto-refreshing data...", new Date().toLocaleTimeString());
//       fetchData(false);
//     }, 10000);
    
//     // Cleanup interval on component unmount
//     return () => {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     };
//   }, [token]);

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading market data...</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <ToastContainer />
      
//       <div className="percentage-card">
//         {/* Header */}
//         <div
//           onClick={() => setShowToggler(!showToggler)}
//           className="card-header"
//         >
//           <div>
//             <h3>Hero Session</h3> 
//           </div>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             {/* Refresh Button */}
//             {/* <button 
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleManualRefresh();
//               }}
//               className="refresh-btn"
//               title="Refresh Data"
//             >
//               🔄
//             </button> */}
//             <span>
//               {showToggler ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
//             </span>
//           </div>
//         </div>

//         {showToggler && (
//           <div className="cards-container">
//             {/* LEFT SECTION - GP (Gross Profit / UPPER RANGE) */}
//             <div className="card-left">
//               <div className="card-title-left">
//                 <h4>📈 GP - Gross Profit  
//                   <span className="stats-count"> ({leftStats.count} Items)</span>
//                   <span className="stats-avg"> | Avg: {formatPercentage(leftStats.average)}</span>
//                 </h4>
//               </div>
              
//               <div className="chips-grid">
//                 {groupedData.left.length === 0 ? (
//                   <div className="no-data">
//                     <span>📭 No GP data available</span>
//                     <span className="no-data-hint">(Waiting for type zero data)</span>
//                   </div>
//                 ) : (
//                   groupedData.left.map((btn, idx) => (
//                     <button
//                       key={idx}
//                       className={`tiny-chip ${btn.type}`}
//                       onClick={() => copyToClipboard(btn.symbol, btn.symbol)}
//                       onMouseEnter={(e) => handleMouseEnter(e, btn)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <span className="chip-symbol" title={btn.symbol}>
//                         {btn.symbol.length > 20 ? btn.symbol.slice(0, 18) + '..' : btn.symbol}
//                       </span>
//                       <span className="chip-sep">|</span>
//                       <span className={`chip-percent ${btn.type}`}>
//                         {formatPercentage(btn.percentage)}
//                       </span>
//                     </button>
//                   ))
//                 )}
//               </div>
//             </div>

//             {/* RIGHT SECTION - GD (Gross Drawdown / DOWN RANGE) */}
//             <div className="card-right">
//               <div className="card-title-right">
//                 <h4>📉 GD - Gross Drawdown 
//                   <span className="stats-count"> ({rightStats.count} Items)</span>
//                   <span className="stats-avg"> | Avg: {formatPercentage(rightStats.average)}</span>
//                 </h4>
//               </div>
              
//               <div className="chips-grid">
//                 {groupedData.right.length === 0 ? (
//                   <div className="no-data">
//                     <span>📭 No GD data available</span>
//                     <span className="no-data-hint">(Waiting for type zero data)</span>
//                   </div>
//                 ) : (
//                   groupedData.right.map((btn, idx) => (
//                     <button
//                       key={idx}
//                       className={`tiny-chip ${btn.type}`}
//                       onClick={() => copyToClipboard(btn.symbol, btn.symbol)}
//                       onMouseEnter={(e) => handleMouseEnter(e, btn)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <span className="chip-symbol" title={btn.symbol}>
//                         {btn.symbol.length > 20 ? btn.symbol.slice(0, 18) + '..' : btn.symbol}
//                       </span>
//                       <span className="chip-sep">|</span>
//                       <span className={`chip-percent ${btn.type}`}>
//                         {formatPercentage(btn.percentage)}
//                       </span>
//                     </button>
//                   ))
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Custom Tooltip */}
//       {hoveredItem && (
//         <div
//           className="custom-tooltip"
//           style={{
//             position: 'fixed',
//             left: `${hoverPosition.x}px`,
//             top: `${hoverPosition.y}px`,
//             zIndex: 9999,
//           }}
//         >
//           <div className="tooltip-content">
//             <div className="tooltip-row">
//               <span className="tooltip-label">Symbol:</span>
//               <span className="tooltip-value">{hoveredItem.symbol}</span>
//             </div>
//             <div className="tooltip-row">
//               <span className="tooltip-label">Price:</span>
//               <span className="tooltip-value">{formatPrice(hoveredItem.price)}</span>
//             </div>
//             <div className="tooltip-row">
//               <span className="tooltip-label">Change:</span>
//               <span className={`tooltip-value ${hoveredItem.type}`}>
//                 {formatPercentage(hoveredItem.percentage)}
//               </span>
//             </div>
//             <div className="tooltip-row">
//               <span className="tooltip-label">Category:</span>
//               <span className="tooltip-value">{hoveredItem.cat}</span>
//             </div>
//             <div className="tooltip-row">
//               <span className="tooltip-label">Session Type:</span>
//               <span className="tooltip-value" style={{ color: '#fbbf24' }}>Zero Session (type: 0)</span>
//             </div>
//             <div className="tooltip-row">
//               <span className="tooltip-label">Time:</span>
//               <span className="tooltip-value">{formatTime(hoveredItem.time)}</span>
//             </div>
//             <div className="tooltip-divider"></div>
//             <div className="tooltip-footer">
//               ✨ Click to copy symbol
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default HeroSession;



import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../context/auth';
import { useNavigate } from 'react-router-dom';
import "../cssStyle/PercentageCard.css";

function ZeroSession() {
  const [showToggler, setShowToggler] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
  const [groupedData, setGroupedData] = useState({
    left: [],
    right: []
  });
  // Stats for left and right sections
  const [leftStats, setLeftStats] = useState({ count: 0, average: 0 });
  const [rightStats, setRightStats] = useState({ count: 0, average: 0 });
  const [lastUpdated, setLastUpdated] = useState(null);
  
  // Reference for interval
  const intervalRef = useRef(null);
  
  const { getAdminAuthToken } = useAuth();
  const navigate = useNavigate();
  const token = getAdminAuthToken();

  // Format percentage function with null/undefined check
  const formatPercentage = (percentage) => {
    if (percentage === undefined || percentage === null || isNaN(percentage)) {
      return '0.00%';
    }
    const sign = percentage >= 0 ? '+' : '';
    return `${sign}${Math.abs(percentage).toFixed(2)}%`;
  };

  const formatPrice = (price) => {
    if (price === undefined || price === null || isNaN(price)) {
      return '₹0.00';
    }
    return `₹${price.toFixed(2)}`;
  };

  const formatTime = (time) => {
    if (!time) return 'N/A';
    const date = new Date(time);
    return date.toLocaleString();
  };

  // ✅ ONLY check if item type is "zero"
  const isTypeZero = (item) => {
    if (!item || !item.type) return false;
    // Only show 'zero' type
    if (item.type === 'zero') return true;
    return false;
  };

  // Fetch data function
  const fetchData = async (showToast = false) => {
    if (!token) {
      setLoading(false);
      if (showToast) toast.error("Please login first");
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    try {
      const response = await axios.get(
        "https://api.algocontroller.com/admin_app/getting_admin_analysis",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const rawData = response.data?.data || [];
      setApiData(rawData);
      processDataByCategory(rawData);
      setLastUpdated(new Date());
      setLoading(false);
      
      if (showToast) {
        toast.info(`Data updated!`, {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "12px" }
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      if (err.response?.status === 401) {
        toast.error("Session expired. Please login again.");
        setTimeout(() => navigate('/login'), 2000);
      } else if (showToast) {
        toast.error("Failed to fetch data");
      }
      setLoading(false);
    }
  };

  const processDataByCategory = (rawData) => {
    // GP category for LEFT (Positive/UPPER RANGE)
    const leftCategories = ['GP'];
    // GD category for RIGHT (Negative/DOWN RANGE)
    const rightCategories = ['GD'];
    
    let leftItems = [];
    let rightItems = [];

    if (!rawData || !Array.isArray(rawData)) {
      setGroupedData({ left: [], right: [] });
      setLeftStats({ count: 0, average: 0 });
      setRightStats({ count: 0, average: 0 });
      return;
    }

    rawData.forEach(insItem => {
      if (insItem.data && Array.isArray(insItem.data)) {
        insItem.data.forEach(item => {
          // ✅ ONLY show 'zero' type data
          if (!isTypeZero(item)) return;
          
          // Zero type data mein percentage nahi hoti, isliye 0 set karo
          const percentageValue = item.percentage !== undefined ? item.percentage : 0;
          
          console.log("✅ Zero type data found:", {
            symbol: item.symbol,
            type: item.type,
            cat: item.cat,
            percentage: percentageValue,
            price: item.price
          });
          
          const buttonData = {
            symbol: item.symbol || 'Unknown',
            price: item.price || 0,
            percentage: percentageValue,
            cat: item.cat || 'Unknown',
            type: percentageValue >= 0 ? "green" : "red",
            time: item.time,
            ins_id: item.ins_id,
            prev_row_close: item.prev_row_close,
            originalType: item.type
          };

          if (leftCategories.includes(item.cat)) {
            leftItems.push(buttonData);
          } else if (rightCategories.includes(item.cat)) {
            rightItems.push(buttonData);
          }
        });
      }
    });

    console.log("📊 Zero Type Data Summary:", {
      leftItemsCount: leftItems.length,
      rightItemsCount: rightItems.length,
      leftSample: leftItems.slice(0, 2),
      rightSample: rightItems.slice(0, 2)
    });

    // Remove duplicates based on symbol
    leftItems = removeDuplicates(leftItems);
    rightItems = removeDuplicates(rightItems);

    // SORTING: Descending order (higher percentage first) for GP
    leftItems.sort((a, b) => (b.percentage || 0) - (a.percentage || 0));
    // SORTING: Ascending order (more negative first) for GD
    rightItems.sort((a, b) => (a.percentage || 0) - (b.percentage || 0));

    // Calculate stats for LEFT section (GP)
    const leftCount = leftItems.length;
    const leftAvg = leftCount > 0 
      ? leftItems.reduce((sum, item) => sum + (item.percentage || 0), 0) / leftCount 
      : 0;
    
    // Calculate stats for RIGHT section (GD)
    const rightCount = rightItems.length;
    const rightAvg = rightCount > 0 
      ? rightItems.reduce((sum, item) => sum + (item.percentage || 0), 0) / rightCount 
      : 0;

    setLeftStats({ count: leftCount, average: leftAvg });
    setRightStats({ count: rightCount, average: rightAvg });
    setGroupedData({ left: leftItems, right: rightItems });
  };

  const removeDuplicates = (items) => {
    const uniqueMap = new Map();
    items.forEach(item => {
      const key = `${item.symbol}_${item.cat}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, item);
      }
    });
    return Array.from(uniqueMap.values());
  };

  const copyToClipboard = async (text, label) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copied!`, {
        position: "top-right",
        autoClose: 1000,
        style: { fontSize: "12px", padding: "6px 12px" }
      });
    } catch (err) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      toast.info(`${label} copied!`);
    }
  };

  // Manual refresh handler
  const handleManualRefresh = () => {
    fetchData(true);
  };

  // SMART TOOLTIP POSITIONING
  const handleMouseEnter = (e, item) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let leftPos = rect.right + 10;
    let topPos = rect.top;
    
    const tooltipWidth = 260;
    const tooltipHeight = 220;
    
    if (leftPos + tooltipWidth > viewportWidth) {
      leftPos = rect.left - tooltipWidth - 10;
    }
    
    if (leftPos < 10) {
      leftPos = 10;
    } 
    
    if (topPos + tooltipHeight > viewportHeight) {
      topPos = viewportHeight - tooltipHeight - 10;
    }
    
    if (topPos < 10) {
      topPos = 10;
    }
    
    setHoverPosition({
      x: leftPos,
      y: topPos
    });
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  // Initial fetch and set interval for every 10 seconds
  useEffect(() => {
    if (!token) {
      setLoading(false);
      toast.error("Please login first");
      setTimeout(() => navigate('/login'), 2000);
      return;
    }
    
    // Initial fetch
    fetchData(false);
    
    // Set interval to fetch every 10 seconds
    intervalRef.current = setInterval(() => {
      console.log("Auto-refreshing data...", new Date().toLocaleTimeString());
      fetchData(false);
    }, 10000);
    
    // Cleanup interval on component unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [token]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading market data...</p>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      
      <div className="percentage-card">
        <div
          onClick={() => setShowToggler(!showToggler)}
          className="card-header"
        >
          <div>
            <h3> Zero Session </h3>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* Refresh Button */}
            {/* <button 
              onClick={(e) => {
                e.stopPropagation();
                handleManualRefresh();
              }}
              className="refresh-btn"
              title="Refresh Data"
            >
              🔄
            </button> */}
            <span>
              {showToggler ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
            </span>
          </div>
        </div>

        {showToggler && (
          <div className="cards-container">
            {/* LEFT SECTION - GP (Gross Profit / UPPER RANGE) */}
            <div className="card-left">
              <div className="card-title-left">
                <h4>📈 GP - Gross Profit  
                  <span className="stats-count"> ({leftStats.count} Items)</span>
                  <span className="stats-avg"> | Avg: {formatPercentage(leftStats.average)}</span>
                </h4>
              </div>
              
              <div className="chips-grid">
                {groupedData.left.length === 0 ? (
                  <div className="no-data">
                    <span>📭 No GP data available</span>
                    <span className="no-data-hint">(Waiting for type "zero" data)</span>
                  </div>
                ) : (
                  groupedData.left.map((btn, idx) => (
                    <button
                      key={idx}
                      className={`tiny-chip ${btn.type}`}
                      onClick={() => copyToClipboard(btn.symbol, btn.symbol)}
                      onMouseEnter={(e) => handleMouseEnter(e, btn)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <span className="chip-symbol" title={btn.symbol}>
                        {btn.symbol.length > 20 ? btn.symbol.slice(0, 18) + '..' : btn.symbol}
                      </span>
                      <span className="chip-sep">|</span>
                      <span className={`chip-percent ${btn.type}`}>
                        {formatPercentage(btn.percentage)}
                      </span>
                    </button>
                  ))
                )}
              </div>
            </div>

            {/* RIGHT SECTION - GD (Gross Drawdown / DOWN RANGE) */}
            <div className="card-right">
              <div className="card-title-right">
                <h4>📉 GD - Gross Drawdown 
                  <span className="stats-count"> ({rightStats.count} Items)</span>
                  <span className="stats-avg"> | Avg: {formatPercentage(rightStats.average)}</span>
                </h4>
              </div>
              
              <div className="chips-grid">
                {groupedData.right.length === 0 ? (
                  <div className="no-data">
                    {/* <span>📭 No GD data available</span> */}
                    {/* <span className="no-data-hint">(Waiting for type "zero" data)</span> */}
                  </div>
                ) : (
                  groupedData.right.map((btn, idx) => (
                    <button
                      key={idx}
                      className={`tiny-chip ${btn.type}`}
                      onClick={() => copyToClipboard(btn.symbol, btn.symbol)}
                      onMouseEnter={(e) => handleMouseEnter(e, btn)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <span className="chip-symbol" title={btn.symbol}>
                        {btn.symbol.length > 20 ? btn.symbol.slice(0, 18) + '..' : btn.symbol}
                      </span>
                      <span className="chip-sep">|</span>
                      <span className={`chip-percent ${btn.type}`}>
                        {formatPercentage(btn.percentage)}
                      </span>
                    </button>
                  ))
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Custom Tooltip */}
      {hoveredItem && (
        <div
          className="custom-tooltip"
          style={{
            position: 'fixed',
            left: `${hoverPosition.x}px`,
            top: `${hoverPosition.y}px`,
            zIndex: 9999,
          }}
        >
          <div className="tooltip-content">
            <div className="tooltip-row">
              <span className="tooltip-label">Symbol:</span>
              <span className="tooltip-value">{hoveredItem.symbol}</span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Price:</span>
              <span className="tooltip-value">{formatPrice(hoveredItem.price)}</span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Change:</span>
              <span className={`tooltip-value ${hoveredItem.type}`}>
                {formatPercentage(hoveredItem.percentage)}
              </span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Category:</span>
              <span className="tooltip-value">{hoveredItem.cat}</span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Session Type:</span>
              <span className="tooltip-value" style={{ color: '#fbbf24' }}>Zero Session (type: "zero")</span>
            </div>
            <div className="tooltip-row">
              <span className="tooltip-label">Time:</span>
              <span className="tooltip-value">{formatTime(hoveredItem.time)}</span>
            </div>
            <div className="tooltip-divider"></div>
            <div className="tooltip-footer">
              ✨ Click to copy symbol
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ZeroSession;